<template>
  <custom-dialog
    :widthDialog="'1010px'"
    :classDialog="'create-dialog custome-dialog'"
    :offsetTop="'3vh'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">{{ buildHeader() }}</h5>
    </template>
    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="120px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Tên node" prop="stepName">
              <el-input
                v-model="form.stepName"
                placeholder="Tên node"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="150"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Mã" prop="code">
              <el-input
                v-model="form.code"
                placeholder="Mã"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="50"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="isIncomingFlow">
            <el-form-item prop="stepType" label="Loại node">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.stepType"
                placeholder="Loại node"
                size="medium"
                @change="stepTypeChanged"
                :disabled="isStepTypeDisabled"
              >
                <el-option
                  v-for="item in stepTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="6" v-if="isOutgoingFlow">
            <el-form-item label="Ký số" prop="signType">
              <el-checkbox
                :border="false"
                v-model="form.signType"
                class="style-fullWidth"
              >
              </el-checkbox>
            </el-form-item>
          </el-col> -->

          <el-col :span="6">
            <el-form-item label="Hoạt động" prop="status">
              <el-checkbox
                :border="false"
                v-model="form.status"
                class="style-fullWidth"
              >
              </el-checkbox>
            </el-form-item>
          </el-col>

          <el-col :span="6" v-if="isIncomingFlow && isCxlCaNhan">
            <el-form-item label="Cho phép từ chối" prop="isAbleToReject">
              <el-checkbox
                :border="false"
                v-model="form.isAbleToReject"
                class="style-fullWidth"
              >
              </el-checkbox>
            </el-form-item>
          </el-col>

          <el-col :span="6" v-if="isOutgoingFlow">
            <el-form-item label="Tự kết thúc" prop="endTask">
              <el-checkbox
                :border="false"
                v-model="form.endTask"
                class="style-fullWidth"
              >
              </el-checkbox>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <vb-step-info-tables
              :isOutgoingFlow="isOutgoingFlow"
              :vbStepInfoForms="vbStepInfoForms"
              :context="context"
              :stepType="form.stepType"
              @addVbStepInfoForms="addVbStepInfoForms"
              @deleteVbStepInfoForm="deleteVbStepInfoForm"
              @updateStepInfoForm="updateStepInfoForm"
            ></vb-step-info-tables>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button size="medium" type="success" @click="submit">
          <i class="far fa-check-circle"></i>
          &nbsp;Lưu
        </el-button>
        <el-button
          v-if="isAbleToDelete"
          size="medium"
          type="danger"
          @click="delete_"
        >
          <i class="far fa-trash"></i>
          &nbsp;Xóa
        </el-button>
        <el-button type="info" size="medium" @click="$emit('closeDialog')"
          >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import constants from "../../../constants";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import cauHinhLuongUtils from "../../../services/cauhinhluong/cauHinhLuongUtils";
import h from "../../../services/h";
import utils from "../../../services/utils";
import CustomDialog from "../../common/custom-dialog";
import VbStepInfoTables from "./vb-step-info-tables";

export default {
  name: "vb-step-detail-dialog",
  components: { VbStepInfoTables, CustomDialog },
  props: ["isOpen", "context"],
  //context : {vbFlowForm,vbStepInfoForms,vbStepToStepForms,currentAction,selectedPoint}
  data() {
    return {
      form: {
        stepName: null,
        // signType: null,
        status: null,
        code: null,
        isAbleToReject: null,
        stepType: null,
        endTask: false,
      },
      rules: {
        stepName: null,
        // signType: null,
        status: null,
        code: null,
        isAbleToReject: null,
        stepType: null,
      },
      vbStepInfoForms: [],
      isAbleToDelete: false,
      stepTypeOptions: null,
      isStepTypeDisabled: false,
    };
  },

  computed: {
    isOutgoingFlow() {
      return cauHinhLuongUtils.isOutgoingFlow(this.context.vbFlowForm);
    },
    isIncomingFlow() {
      return cauHinhLuongUtils.isIncomingFlow(this.context.vbFlowForm);
    },
    isCxlCaNhan() {
      return this.form.stepType === constants.STEP.STEP_TYPE.CANHAN;
    },
    isCxlDonVi() {
      return this.form.stepType === constants.STEP.STEP_TYPE.DONVI;
    },
  },

  created() {
    this.initComponent();
  },

  methods: {
    initStepTypeOptions() {
      this.stepTypeOptions = [
        {
          value: constants.STEP.STEP_TYPE.CANHAN,
          label: errorMessageFilter({ errorCode: "vbStep.stepType.caNhan" }),
        },
        {
          value: constants.STEP.STEP_TYPE.DONVI,
          label: errorMessageFilter({ errorCode: "vbStep.stepType.donVi" }),
        },
      ];
    },

    stepTypeChanged() {
      // this.form.signType = false;
      this.form.isAbleToReject = false;
      this.vbStepInfoForms = [];
    },

    initActions() {
      //được phép xóa nếu ở chế độ sửa node & node chưa được insert trong db;
      let isInsertedData =
        this.context.currentAction ===
          constants.CAU_HINH_LUONG_PAGE.ACTION.VIEW_NODE &&
        h.exists(
          this.context.vbSteps,
          (vbStep_) => vbStep_.id === this.context.selectedPoint.vbStepForm.id
        );

      this.isAbleToDelete =
        this.context.currentAction ===
          constants.CAU_HINH_LUONG_PAGE.ACTION.VIEW_NODE && !isInsertedData;

      //không cho sửa nếu được insert trong db;
      this.isStepTypeDisabled = isInsertedData;
    },

    updateStepInfoForm({ vbStepInfoForm, form }) {
      vbStepInfoForm.userId = form.userId;
      vbStepInfoForm.roleId = form.roleId;
      vbStepInfoForm.deptId = form.deptId;
      vbStepInfoForm.status = form.status;
      vbStepInfoForm.fullName = form.fullName;
      vbStepInfoForm.roleName = form.roleName;
      vbStepInfoForm.deptName = form.deptName;
      vbStepInfoForm.status = form.status;
      if (this.isOutgoingFlow) {
        vbStepInfoForm.signType = form.signType;
        vbStepInfoForm.signSmartCA = form.signSmartCA;
        vbStepInfoForm.signToken = form.signToken;
      }
    },

    deleteVbStepInfoForm({ form }) {
      this.vbStepInfoForms.splice(this.vbStepInfoForms.indexOf(form), 1);
    },

    addVbStepInfoForms({ forms }) {
      this.vbStepInfoForms.push(...forms);
    },

    initValidationRules() {
      let defaultRequiredConstrains = utils.buildRequiredValidationConstrains();
      this.rules.stepName = [defaultRequiredConstrains];
    },

    validateForm() {
      return utils.validateFormCommon(this.$refs.form, this.$message);
    },

    validateDuplicateName() {
      return new Promise((resolve) => {
        let vbStepForm = this.context.selectedPoint.vbStepForm;

        let isDuplicateName =
          (this.context.currentAction ===
            constants.CAU_HINH_LUONG_PAGE.ACTION.ADD_NODE ||
            vbStepForm.stepName !== this.form.stepName) &&
          h.exists(
            this.context.vbStepForms,
            (vbStepForm) => vbStepForm.stepName === this.form.stepName
          );

        if (isDuplicateName) {
          this.$message.error(
            errorMessageFilter({ errorCode: "vbFlow.duplicateStepName" })
          );
        } else {
          resolve();
        }
      });
    },

    convertToSubmitForm() {
      let vbStepForm = {
        stepName: this.form.stepName,
        stepType: this.form.stepType,
        // signType: this.form.signType
        //   ? constants.STEP_INFO_SIGN_TYPE.KI_SO
        //   : null,
        code: this.form.code,
        status: this.form.status
          ? constants.STATUS_.ACTIVE
          : constants.STATUS_.DEACTIVE,
        isAbleToReject: this.form.isAbleToReject
          ? constants.TRUE
          : constants.FALSE,
        endTask: this.form.endTask,
      };
      let vbStepInfoForms = this.vbStepInfoForms.map((item) => {
        return {
          ...item,
          signType: item.signType ? constants.STEP_INFO_SIGN_TYPE.KI_SO : null,
          signSmartCA: item.signSmartCA ? constants.STEP_INFO_SIGN_TYPE.KI_SO : null,
          signToken: item.signToken ? constants.STEP_INFO_SIGN_TYPE.KI_SO : null,
        };
      });
      return { vbStepForm, vbStepInfoForms };
    },

    submit() {
      return this.validateForm()
        .then(() => this.validateDuplicateName())
        .then(() => {
          this.$emit("submit", { form: this.convertToSubmitForm() });
        });
    },

    delete_() {
      return utils
        .confirm(
          this.$confirm,
          errorMessageFilter({ errorCode: "vbFlow.vbStep.delete.confirm" })
        )
        .then(() =>
          this.$emit("delete", { id: this.context.selectedPoint._id })
        );
    },

    bindDataToForm() {
      let vbStepForm = this.context.selectedPoint.vbStepForm;
      this.form.stepName = vbStepForm.stepName;
      this.form.stepType = vbStepForm.stepType;
      // this.form.signType =
      //   vbStepForm.signType === constants.STEP_INFO_SIGN_TYPE.KI_SO;
      this.form.status = vbStepForm.status === constants.STATUS_.ACTIVE;
      this.form.endTask = vbStepForm.endTask;
      this.form.code = vbStepForm.code;
      this.form.isAbleToReject = vbStepForm.isAbleToReject === constants.TRUE;

      this.vbStepInfoForms = h.collect(
        h.findAll(
          this.context.vbStepInfoForms,
          (item) => item.stepId === vbStepForm.id
        ),
        (vbStepInfoForm) => {
          return {
            id: vbStepInfoForm.id,
            userId: vbStepInfoForm.userId,
            roleId: vbStepInfoForm.roleId,
            deptId: vbStepInfoForm.deptId,
            fullName: vbStepInfoForm.fullName,
            roleName: vbStepInfoForm.roleName,
            deptName: vbStepInfoForm.deptName,
            status: vbStepInfoForm.status,
            signType:
              vbStepInfoForm.signType === constants.STEP_INFO_SIGN_TYPE.KI_SO,
            signSmartCA:
              vbStepInfoForm.signSmartCA === constants.STEP_INFO_SIGN_TYPE.KI_SO,
            signToken:
              vbStepInfoForm.signToken === constants.STEP_INFO_SIGN_TYPE.KI_SO,
          };
        }
      );
    },

    initFormForCreate() {
      this.form.signType = false;
      this.form.status = true;
      this.form.stepType = constants.STEP.STEP_TYPE.CANHAN;
      this.vbStepInfoForms = [];
    },

    buildHeader() {
      switch (this.context.currentAction) {
        case constants.CAU_HINH_LUONG_PAGE.ACTION.ADD_NODE:
          return "Thêm mới node";

        case constants.CAU_HINH_LUONG_PAGE.ACTION.VIEW_NODE:
        default:
          return "Cập nhật thông tin node";
      }
    },

    initComponent() {
      this.initValidationRules();
      this.initStepTypeOptions();

      switch (this.context.currentAction) {
        case constants.CAU_HINH_LUONG_PAGE.ACTION.ADD_NODE:
          this.initFormForCreate();
          break;

        case constants.CAU_HINH_LUONG_PAGE.ACTION.VIEW_NODE:
        default:
          this.bindDataToForm();
          break;
      }

      this.initActions();
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/setting/cau-hinh-luong-v2/vb-step-detail-dialog.vue